import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';
import { API_URL } from '@/settings';

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    introduction: [],
    brands: [],
    awardspublications: [],
    projects: [],
    projectThumbnails: [],
    imprint: [],
    homesections: [],
  },
  getters: {
    getAwardText: (state) => {

      const res = {
        award_title: state.homesections.award_title,
        award_description: state.homesections.award_description
      }
      return res;
    },
    getBrandsText: (state) => {

      const res = {
        brands_title: state.homesections.brands_title,
        brands_description: state.homesections.brands_description
      }
      return res;
    }

  },
  actions: {

    UPDATE_INTRODUCTION: ({
      commit,
    }) => new Promise((resolve, reject) => {
      axios.get(`${API_URL}items/introduction`)
        .then((response) => {
          // console.log(response.data.data[0]);
          commit('SET_INTRODUCTION', response.data.data[0]);
          resolve(true);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    }),
    UPDATE_BRANDS: ({
      commit,
    }) => new Promise((resolve, reject) => {
      axios.get(`${API_URL}items/brands?sort=sort`)
        .then((response) => {
        // console.log(response.data.data);
          commit('SET_BRANDS', response.data.data);
          resolve(true);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    }),
    UPDATE_AWARDSPUBLICATIONS: ({
      commit,
    }) => new Promise((resolve, reject) => {
      axios.get(`${API_URL}items/awardspublications?sort=sort`)
        .then((response) => {
          // console.log(response.data.data);
          commit('SET_AWARDSPUBLICATIONS', response.data.data);
          resolve(true);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    }),
    UPDATE_PROJECTS: ({
      commit,
    }) => new Promise((resolve, reject) => {
      axios.get(`${API_URL}items/projects?sort=sort`)
        .then((response) => {
          // console.log(response.data.data);
          commit('SET_PROJECTS', response.data.data);
          resolve(true);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    }),
    UPDATE_PROJECTTHUMBNAILS: ({
      commit, rootState,
    }) => new Promise((resolve, reject) => {
      // console.log('rootState.projects');
      // console.log(rootState.projects);
      const projectThumbIds = rootState.projects.map(project => project.teaserimage).toString();
      // console.log('projectThumbIds');
      // console.log(projectThumbIds);
      axios.get(`${API_URL}files/${projectThumbIds}`)
        .then((response) => {
          // console.log(response.data.data);
          commit('SET_PROJECTTHUMBNAILS', response.data.data);
          resolve(true);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    }),
    UPDATE_IMPRINT: ({
      commit,
    }) => new Promise((resolve, reject) => {
      axios.get(`${API_URL}items/imprint`)
        .then((response) => {
          // console.log(response.data.data[0]);
          commit('SET_IMPRINT', response.data.data[0]);
          resolve(true);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    }),
    UPDATE_HOMESECTIONS: ({
      commit,
    }) => new Promise((resolve, reject) => {
      axios.get(`${API_URL}items/Homesections`)
        .then((response) => {
          // console.log(response.data.data[0]);
          commit('SET_HOMESECTIONS', response.data.data[0]);
          resolve(true);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    }),
  },
  mutations: {
    SET_INTRODUCTION: (state, value) => {
      state.introduction = value;
    },
    SET_BRANDS: (state, value) => {
      state.brands = value;
    },
    SET_AWARDSPUBLICATIONS: (state, value) => {
      state.awardspublications = value;
    },
    SET_PROJECTS: (state, value) => {
      state.projects = value;
    },
    SET_PROJECTTHUMBNAILS: (state, value) => {
      state.projectThumbnails = value;
    },
    SET_IMPRINT: (state, value) => {
      state.imprint = value;
    },
    SET_HOMESECTIONS: (state, value) => {
      state.homesections = value;
    },
  },
});

export default store;
